import {
  ApiBlueprint,
  createFrontendPlugin,
  microsoftAuthApiRef,
} from '@backstage/frontend-plugin-api';
import {
  EntityCardBlueprint,
  EntityContentBlueprint,
} from '@backstage/plugin-catalog-react/alpha';
import { Icon } from '@iconify/react';
import {
  isComponentEntity,
  isDataProductEntity,
  isOrganisationDsoEntity,
  isSolutionEntity,
} from '@ipen-portal/ipen-entity-model';
import { or } from '@ipen-portal/plugin-common';

import { MsIamApiClient } from './api/MsIamApiClient';
import { msApimAccessControlApiRef } from './apis';

export const iamPlugin = createFrontendPlugin({
  extensions: [
    ApiBlueprint.make({
      name: 'MsApimAccessControlApi',
      params: defineParams =>
        defineParams({
          api: msApimAccessControlApiRef,
          deps: {
            microsoftAuthApi: microsoftAuthApiRef,
          },
          factory: ({ microsoftAuthApi }) =>
            new MsIamApiClient({ microsoftAuthApi }),
        }),
    }),

    EntityContentBlueprint.make({
      name: 'OrganisationIamPage',
      params: {
        filter: isOrganisationDsoEntity,
        icon: <Icon icon="carbon:api-1" />,
        // TO-DO move buttons to toolbar (see usage of EntityContentWithToolbarBlueprint)
        loader: async () =>
          import('./components/OrganisationIam/OrganisationIamPage').then(m => (
            <m.OrganisationIamPage />
          )),
        path: '/organisation-iam',
        title: 'IAM',
      },
    }),

    EntityCardBlueprint.make({
      name: 'app-roles',
      params: {
        filter: or(isComponentEntity, isSolutionEntity, isDataProductEntity),
        loader: async () =>
          import('./components/AppRolesCard/AppRolesCard').then(m => (
            <m.AppRolesCard />
          )),
      },
    }),
  ],
  pluginId: 'iam',
});
